export const SignupType = Object.freeze({
  LOGIN: "LOGIN",
  RESET: "RESET",
  ACTIVATE: "ACTIVATE",
});